import React, { Component } from 'react';
import Header from '../../Components/Header';
import {
  ContainerWindowTitle,
  SubTitulo,
  Linha,
  LinhaRodape,
  DivRodape,
  Container,
  DivDetalhe,
  BoxCarregarImagem,
  UploadFile,
} from './styles';
import api from '../../services/api';
import { formatOracleDateToBr, alerta, getCurrentDate, isValidDate } from '../../services/funcoes';
import { getFromStorage } from '../../services/auth';
import DirectTituloJanela from '../../Components/@bit/DirectTituloJanela/index';
import { Icon, Checkbox } from 'react-materialize';
import { tratarErros } from '../../services/funcoes';
import noNewsImage from '../../assets/images/noimage.jpg';
import moment from 'moment';
import NumberFormat from 'react-number-format';

export default class NewsPortalAdd extends Component {
  state = {
    loading: false,
    DNP_ID: undefined,
    resumeNews: '',
    subject: '',
    newsImage: undefined,
    finalDate: '',
    initialDate: '',
    statusNews: true,
    linkNews: '',
  };

  /*INICIALIZACAO TELA*/
  async componentDidMount() {
    this.setState({ loading: true });
    await this.carregarVariaveisEstado();
    await this.loadPortalNews();
    this.setState({ loading: false });
  }

  carregarVariaveisEstado = async (e) => {
    const sessao = getFromStorage();

    var str = this.props.location.pathname;
    var res = str.split('/');
    //
    //
    if (res[2] !== undefined && res[2] !== 'novo' && res[2] !== '') {
      this.setState({ DNP_ID: parseInt(res[2]) });
    } else {
      this.setState({ DNP_ID: undefined });
    }

    this.setState({
      empresaAtiva: sessao.empresaId,
      usuarioAtivo: sessao.codigoUsuario,
      empresaCfId: sessao.empresaCfId,
    });
  };

  loadPortalNews = async () => {
    try {
      const { DNP_ID } = this.state;
      if (DNP_ID === undefined) {
        return;
      }
      let url = `/v1/portalnews/` + DNP_ID;
      const retorno = await api.get(url);
      if (!retorno) {
        this.setState({ portalNews: [] });
      } else {
        if (retorno.data && retorno.data.sucess) {
          if (retorno.data.data.length === 0) {
            this.setState({ portalNews: [] });
          } else {
            //

            let resumeNews = retorno.data.data[0].DNP_RESUMO_MENSAGEM;
            let subject = retorno.data.data[0].DNP_ASSUNTO;
            let newsImage = retorno.data.data[0].DNP_MENSAGEM;
            let finalDate = formatOracleDateToBr(retorno.data.data[0].DNP_DATA_FINAL);
            let initialDate = formatOracleDateToBr(retorno.data.data[0].DNP_DATA_INICIAL);
            let statusNews = retorno.data.data[0].DNP_FLG_STATUS_ID === 1;
            let linkNews = retorno.data.data[0].DNP_LINK;

            this.setState({
              resumeNews,
              subject,
              finalDate,
              initialDate,
              statusNews,
              linkNews,
              newsImage
            });
          }
        } else {
          this.setState({ portalNews: [] });
        }
      }
    } catch (err) {
      alerta('Erro ao carregar a lista de book básico =>' + err);
      this.setState({ loading: false });
    }
  };

  urlImagemUpada = async (file, tipoImagem) => {
    try {
      const data = new FormData();
      data.append('image', file);
      const retorno = await api.post('/v1/upload/ftp/news/', data);
      if (!retorno) {
        this.setState({ newsImage: noNewsImage });
      } else {
        if (retorno.data && retorno.data.sucess) {
          //
          //
          this.setState({ newsImage: retorno.data.data });
        }
      }
    } catch (err) {
      //
      if (!tratarErros(err)) {
        alerta(
          'Erro => Verifique se o arquivo que você está carregando é uma imagem válida!'
        );
        this.setState({ newsImage: noNewsImage });
      }
    }
  };

  handleClearNewsImage = async () => {
    let { newsImage } = this.state;

    newsImage = noNewsImage;
    this.setState({ newsImage });
  };

  handleChangeNewsImage = async (event) => {
    var imagem = event.target.files[0];
    this.setState({ newsImage: URL.createObjectURL(imagem) });
    await this.urlImagemUpada(imagem, 'logo');
    this.setState({ loading: false });
  };

  handleChangeSubject = (e) => {
    this.setState({ subject: e.target.value });
  };

  handleChangeNewsStatus = (e) => {
    this.setState({ statusNews: e.target.checked });
  };

  handleChangeLinkNews = (e) => {
    this.setState({ linkNews: e.target.value });
  };

  handleChangeResumeNews = (e) => {
    this.setState({ resumeNews: e.target.value });
  };

  handleChangeInitialDataNews = (values) => {
    this.setState({ initialDate: values.formattedValue });
  };

  validarCampos = async () => {
    let erros = '';

    const { resumeNews, subject, linkNews } = this.state;

    //
    const initialDataOK = await this.handleValidaCampoData(
      document.getElementById('initialDate'),
      'vigencia',
      false,
      false
    );
    if (!initialDataOK) {
      erros += 'Verifique a data de vigência. \n';
    }

    const finalDataOk = await this.handleValidaCampoData(
      document.getElementById('finalDate'),
      'validade',
      true,
      false
    );
    if (!finalDataOk) {
      erros += 'Verifique a data de validade. \n';
    }

    const dataValidade = moment(
      document.getElementById('finalDate').value,
      'DD/MM/YYYY'
    );
    const dataVigencia = moment(
      document.getElementById('initialDate').value,
      'DD/MM/YYYY'
    );
    if (dataValidade < dataVigencia) {
      erros +=
        'A data de validade não pode ser menor que a data de vigência. \n';
    }

    if (subject === undefined || subject === '') {
      erros += 'O assunto da novidade é obrigatória. \n';
    }
    if (linkNews === undefined || linkNews === '') {
      erros += 'O link da novidade é obrigatório. \n';
    }
    if (resumeNews === undefined || resumeNews === '') {
      erros += 'O resumo da novidade é obrigatório. \n';
    }

    if (erros !== '') {
      //
      alerta(erros);
      return false;
    } else {
      return true;
    }
  };

  handleChangeFinalDataNews = (values) => {
    this.setState({ finalDate: values.formattedValue });
  };

  handleSaveNews = async () => {
    const {
      usuarioAtivo,
      DNP_ID,
      resumeNews,
      subject,
      newsImage,
      finalDate,
      initialDate,
      statusNews,
      linkNews,
    } = this.state;

    try {
      if ((await this.validarCampos()) === false) {
        return;
      }
      const _news = {};
      let retorno;
      _news.DNP_ID = DNP_ID;
      _news.DNP_ASSUNTO = subject;
      _news.DNP_RESUMO_MENSAGEM = resumeNews;
      _news.DNP_DATA_INICIAL = initialDate;
      _news.DNP_DATA_FINAL = finalDate;
      _news.DNP_FLG_STATUS_ID = statusNews ? 1 : 0;
      _news.DNP_USR_ID = usuarioAtivo;
      _news.DNP_MENSAGEM = newsImage === undefined || newsImage === noNewsImage ? '' : newsImage;
      _news.DNP_LINK = linkNews;
      retorno = await api.post('/v1/portalnews', _news);
      //
      //
      if (!retorno.data.sucess) {
        tratarErros(retorno.data);
      } else {
        alerta('Novidade salva com sucesso!');
        this.props.history.goBack();
      }
    } catch (err) {
      //
      if (!err.response) {
        alerta(err, 2);
      } else {
        //
        tratarErros(err.response.data);
      }
    }
  };

  handleValidaCampoData = async (
    e,
    nomeCampo,
    maiorQueHoje,
    mostrarMensagem
  ) => {
    if (e.value === '') {
      return;
    }
    var dataInformada = moment(e.value, 'DD/MM/YYYY');
    var dataHoje = moment(getCurrentDate(), 'DD/MM/YYYY');
    if (maiorQueHoje) {
      if (!isValidDate(dataInformada) || dataInformada < dataHoje) {
        mostrarMensagem &&
          alerta(
            `A data de ${nomeCampo} inválida! \n Verifique se ela é menor que a data de hoje.`,
            2
          );
        return false;
      }
    } else {
      if (!isValidDate(dataInformada)) {
        mostrarMensagem && alerta(`A data de ${nomeCampo} inválida!`, 2);
        return false;
      }
    }
    return true;
  };

  render() {
    const {
      loading,
      resumeNews,
      subject,
      newsImage,
      finalDate,
      initialDate,
      statusNews,
      linkNews,
    } = this.state;
    return (
      <>
        <Header />
        <ContainerWindowTitle>
          <DirectTituloJanela
            urlVoltar={'/home'}
            titulo={loading ? 'Carregando...' : 'Novidades portal'}
          />
        </ContainerWindowTitle>
        <Container>
          <div
            style={{
              display: loading ? 'block' : 'none',
              position: 'absolute',
              height: '100vh',
              width: '100vw',
              top: '0px',
              left: '0px',
              backgroundColor: '#00000069',
              zIndex: '1',
            }}
          ></div>

          <Linha>
            <DivDetalhe style={{ flex: 1 }}>
              <label htmlFor="subject">Asunto</label>
              <input
                id="subject"
                onChange={this.handleChangeSubject}
                value={subject}
                maxLength={100}
              />
            </DivDetalhe>
            <DivDetalhe style={{ flex: 0 }}>
              <Checkbox
                checked={statusNews !== undefined && statusNews}
                filledIn
                value="1"
                id="Checkbox_3"
                label="Ativo"
                onClick={(event) => {
                  event.persist();
                  this.handleChangeNewsStatus(event);
                }}
              />
            </DivDetalhe>
          </Linha>
          <Linha>
            <DivDetalhe style={{ flex: 1 }}>
              <label htmlFor="subject">Link da notícia</label>
              <input
                id="subject"
                onChange={this.handleChangeLinkNews}
                value={linkNews}
                maxLength={100}
              />
            </DivDetalhe>
          </Linha>
          <Linha>
            <DivDetalhe>
              <label htmlFor="resumeNews">Resumo mensagem</label>
              <input
                id="subject"
                onChange={this.handleChangeResumeNews}
                value={resumeNews}
                maxLength={100}
              />
            </DivDetalhe>
          </Linha>
          <SubTitulo style={{ display: 'flex', alignItems: 'center' }}>
            <Icon>label</Icon>Período veiculação
          </SubTitulo>
          <Linha>
            <DivDetalhe>
              <label htmlFor="initialDate">Data vigência</label>
              <NumberFormat
                format={'##/##/####'}
                value={initialDate}
                id="initialDate"
                onValueChange={this.handleChangeInitialDataNews}
                onBlur={(e) =>
                  this.handleValidaCampoData(
                    document.getElementById('initialDate'),
                    'inicial',
                    false,
                    true
                  )
                }
              />
            </DivDetalhe>
            <DivDetalhe>
              <label htmlFor="finalDate">Data validade</label>
              <NumberFormat
                format={'##/##/####'}
                value={finalDate}
                id="finalDate"
                onValueChange={this.handleChangeFinalDataNews}
                onBlur={(e) => {
                  this.handleValidaCampoData(
                    document.getElementById('finalDate'),
                    'validade',
                    true,
                    true
                  );
                }}
              />
            </DivDetalhe>
          </Linha>
          <Linha>
            <DivDetalhe>
              <SubTitulo style={{ display: 'flex', alignItems: 'center' }}>
                <Icon>label</Icon>Mensagem
              </SubTitulo>
              <BoxCarregarImagem id="imagemMensagem" cols="30" rows="30">
                <div>
                  <p>Imagem mensagem</p>
                  <p>
                    <small>Prefira o padrão retrato</small>
                  </p>
                  <UploadFile>
                    <label
                      htmlFor="input-file"
                      className="saib-button is-secondary"
                      onClick={() =>
                        document.getElementById('imagemMensagemFile').click()
                      }
                    >
                      Carregar
                    </label>
                    <label
                      className="saib-button is-secondary"
                      onClick={this.handleClearNewsImage}
                    >
                      Limpar
                    </label>
                    <input
                      id="imagemMensagemFile"
                      type="file"
                      value=""
                      accept="image/x-png,image/jpeg"
                      onChange={(event) => this.handleChangeNewsImage(event)}
                    />
                    <span id="imagemMensagemSpan"></span>
                  </UploadFile>
                </div>
                <div>
                  <img
                    src={newsImage === undefined  || newsImage === '' || newsImage == null ? noNewsImage : newsImage}
                    width="180"
                    height="180"
                    alt="Imagem do Banner"
                  />
                </div>
              </BoxCarregarImagem>
            </DivDetalhe>
          </Linha>
          <LinhaRodape>
            <DivRodape>
              <button
                className="saib-button is-primary "
                onClick={() => {
                  this.handleSaveNews();
                }}
              >
                <Icon>save</Icon> Salvar
              </button>
              <button
                className="saib-button is-primary "
                onClick={() => {
                  this.props.history.goBack();
                }}
              >
                <Icon>arrow_back</Icon> Cancelar
              </button>
            </DivRodape>
          </LinhaRodape>
        </Container>
      </>
    );
  }
}
